/* HN2 — Home Nordics product page JS for Dawn 15.2 */
(function () {
  if (window.__hn2) return;
  window.__hn2 = true;

  var I18N = (function () { try { var el = document.querySelector('[data-hn2-i18n]'); return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; } })();
  var LANG = document.documentElement.lang || 'en-US';
  function money(cents, cur) {
    try { return new Intl.NumberFormat(LANG, { style: 'currency', currency: cur || 'USD' }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function initCommon(scope) {
    /* Restock month: today + N weeks -> "early|mid|late Month", always advancing */
    scope.querySelectorAll('[data-hn2-restock]').forEach(function (el) {
      var w = parseInt(el.getAttribute('data-weeks'), 10) || 6;
      var d = new Date(); d.setDate(d.getDate() + w * 7);
      var day = d.getDate();
      var part = day <= 10 ? (I18N.restock_early || 'early') : day <= 20 ? (I18N.restock_mid || 'mid') : (I18N.restock_late || 'late');
      el.textContent = part + (/[-’']$/.test(part) ? '' : ' ') + d.toLocaleDateString(LANG, { month: 'long' });
    });
    scope.querySelectorAll('[data-hn2-gallery]').forEach(initGallery);
    scope.querySelectorAll('[data-hn2-product]').forEach(initProduct);
    scope.querySelectorAll('[data-hn2-sticky]').forEach(initSticky);
  }

  function initGallery(g) {
    if (g.__hn2) return; g.__hn2 = 1;
    var track = g.querySelector('[data-hn2-track]');
    var dots = g.querySelectorAll('[data-hn2-dot]');
    if (!track || !dots.length) return;
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
    }, { passive: true });
  }

  function initProduct(sec) {
    if (sec.__hn2) return; sec.__hn2 = 1;
    var form = sec.querySelector('form.hn2-product-form');
    var dataEl = sec.querySelector('[data-hn2-variants]');
    if (!form || !dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var cur = sec.getAttribute('data-currency');
    var colorPos = parseInt(sec.getAttribute('data-color-pos'), 10);
    var addedTimer;

    function selectedOpts() {
      return Array.prototype.slice.call(sec.querySelectorAll('.hn2-opt-input:checked'))
        .sort(function (a, b) { return a.getAttribute('data-pos') - b.getAttribute('data-pos'); })
        .map(function (i) { return i.value; });
    }
    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var j = 0; j < opts.length; j++) { if (variants[i].options[j] !== opts[j]) { ok = false; break; } }
        if (ok) return variants[i];
      }
      return null;
    }
    function update() {
      var opts = selectedOpts();
      var v = findVariant(opts);
      var cta = sec.querySelector('[data-hn2-cta]');
      opts.forEach(function (val, j) {
        sec.querySelectorAll('[data-hn2-selected-opt="' + j + '"]').forEach(function (el) { el.textContent = val; });
        document.querySelectorAll('[data-hn2-sticky-opt="' + j + '"]').forEach(function (el) { el.textContent = val; });
      });
      if (colorPos > -1 && opts[colorPos]) {
        sec.querySelectorAll('[data-hn2-stock-color]').forEach(function (el) { el.textContent = opts[colorPos]; });
      }
      if (!v) { if (cta) { cta.disabled = true; cta.textContent = I18N.unavailable || 'Unavailable'; } return; }
      var idInput = form.querySelector('input[name="id"]');
      if (idInput) idInput.value = v.id;
      var priceLabel = money(v.price, cur);
      sec.querySelectorAll('[data-hn2-price]').forEach(function (el) { el.textContent = priceLabel; });
      document.querySelectorAll('[data-hn2-sticky-price]').forEach(function (el) { el.textContent = priceLabel; });
      var cw = sec.querySelector('[data-hn2-compare-wrap]');
      if (cw) {
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        cw.style.display = onSale ? '' : 'none';
        if (onSale) {
          var ce = cw.querySelector('[data-hn2-compare]');
          if (ce) ce.textContent = money(v.compare_at_price, cur);
          var se = cw.querySelector('[data-hn2-save]');
          if (se) se.textContent = (I18N.save || 'SAVE') + ' ' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%';
        }
      }
      sec.querySelectorAll('[data-hn2-installment]').forEach(function (el) { el.textContent = money(Math.round(v.price / 4), cur); });
      if (cta) {
        cta.disabled = !v.available;
        cta.textContent = v.available ? (I18N.add_to_bag || 'Add to Cart') + ' \u2014 ' + priceLabel : (I18N.sold_out || 'Sold out');
      }
      document.querySelectorAll('[data-hn2-sticky-cta]').forEach(function (b) { b.disabled = !v.available; });
    }

    sec.querySelectorAll('.hn2-opt-input').forEach(function (i) { i.addEventListener('change', update); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var cta = sec.querySelector('[data-hn2-cta]');
      if (cta && cta.disabled) return;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var fd = new FormData(form);
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function') fd.append('sections', 'cart-drawer,cart-icon-bubble');
      fetch(root + 'cart/add.js', { method: 'POST', body: fd })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function (added) {
          /* Hand off to Dawn's drawer so the cart opens with the store's own markup */
          if (drawer && added && added.sections) {
            try { drawer.classList.remove('is-empty'); drawer.renderContents(added); } catch (e) {}
          }
          if (cta) { cta.classList.add('is-added'); cta.textContent = I18N.added_to_bag || '\u2713 Added to cart'; }
          document.querySelectorAll('[data-hn2-sticky-cta]').forEach(function (b) { b.classList.add('is-added'); b.textContent = I18N.added || '\u2713 Added'; });
          clearTimeout(addedTimer);
          addedTimer = setTimeout(function () {
            if (cta) cta.classList.remove('is-added');
            document.querySelectorAll('[data-hn2-sticky-cta]').forEach(function (b) { b.classList.remove('is-added'); b.textContent = I18N.add_to_bag || 'Add to Cart'; });
            update();
          }, 2400);
          /* Refresh Dawn's cart icon bubble */
          fetch(window.location.pathname + '?sections=cart-icon-bubble')
            .then(function (r) { return r.json(); })
            .then(function (d) {
              var el = document.getElementById('cart-icon-bubble');
              if (el && d['cart-icon-bubble']) {
                var t = document.createElement('div');
                t.innerHTML = d['cart-icon-bubble'];
                var n = t.querySelector('#cart-icon-bubble');
                el.innerHTML = n ? n.innerHTML : d['cart-icon-bubble'];
              }
            }).catch(function () {});
        })
        .catch(function () { form.submit(); });
    });

    update();
  }

  function initSticky(bar) {
    if (bar.__hn2) return; bar.__hn2 = 1;
    var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 720;
    var onScroll = function () { bar.classList.toggle('is-visible', window.scrollY > threshold); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    var btn = bar.querySelector('[data-hn2-sticky-cta]');
    if (btn) btn.addEventListener('click', function () {
      var f = document.querySelector('form.hn2-product-form');
      if (f) { if (f.requestSubmit) f.requestSubmit(); else f.submit(); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initCommon(document); });
  } else {
    initCommon(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initCommon(e.target); });
})();

/* ==========================================================================
   HN2 store layer — added when the design was installed (2026-08-15).
   Desktop gallery controls, variant->gallery sync, and the Klarna minimum.
   ========================================================================== */
(function () {
  if (window.__hn2store) return;
  window.__hn2store = true;

  function galleryControls(g) {
    if (g.__hn2nav) return; g.__hn2nav = 1;
    var track = g.querySelector('[data-hn2-track]');
    var slides = g.querySelectorAll('.hn2-gal-slide');
    if (!track || slides.length < 2) return;

    /* Slides sit in a flex row with a gap, so scroll to the slide's own offset
       rather than i * trackWidth, and fall back to an instant jump if the
       smooth scroll does not take (it is a no-op in some embedded views). */
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      var left = slides[i].offsetLeft - track.offsetLeft;
      try { track.scrollTo({ left: left, behavior: 'smooth' }); } catch (e) { track.scrollLeft = left; }
      setTimeout(function () {
        if (Math.abs(track.scrollLeft - left) > 4) track.scrollLeft = left;
        if (g.__hn2edges) g.__hn2edges();
      }, 320);
    }
    function index() {
      var best = 0, bestD = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var d = Math.abs((slides[i].offsetLeft - track.offsetLeft) - track.scrollLeft);
        if (d < bestD) { bestD = d; best = i; }
      }
      return best;
    }

    g.querySelectorAll('[data-hn2-dot]').forEach(function (d, i) {
      d.setAttribute('role', 'button');
      d.setAttribute('tabindex', '0');
      d.setAttribute('aria-label', 'Go to image ' + (i + 1));
      d.addEventListener('click', function () { go(i); });
      d.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(i); } });
    });

    ['prev', 'next'].forEach(function (dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'hn2-gal-nav hn2-gal-' + dir;
      b.setAttribute('aria-label', dir === 'prev' ? 'Previous image' : 'Next image');
      b.innerHTML = dir === 'prev' ? '&#8249;' : '&#8250;';
      b.addEventListener('click', function () { go(index() + (dir === 'prev' ? -1 : 1)); });
      g.appendChild(b);
    });
    var prev = g.querySelector('.hn2-gal-prev'), next = g.querySelector('.hn2-gal-next');
    var dotEls = g.querySelectorAll('[data-hn2-dot]');
    /* The export's own dot handler measures i * trackWidth, which drifts once the
       flex gap is counted; drive the dots from the same offset math as go(). */
    function edges() {
      var i = index();
      prev.hidden = i <= 0;
      next.hidden = i >= slides.length - 1;
      dotEls.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    track.addEventListener('scroll', edges, { passive: true });
    g.__hn2edges = edges;
    edges();
    g.__hn2go = go;
  }

  /* Selecting a colour scrolls the gallery to that variant's own photo */
  function variantGallerySync(sec) {
    if (sec.__hn2sync) return; sec.__hn2sync = 1;
    var dataEl = sec.querySelector('[data-hn2-variants]');
    var gallery = sec.querySelector('[data-hn2-gallery]');
    if (!dataEl || !gallery) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var slides = Array.prototype.slice.call(sec.querySelectorAll('.hn2-gal-slide img'));
    if (!slides.length) return;

    function fileOf(u) {
      if (!u) return '';
      return String(u).split('?')[0].split('/').pop().replace(/_\d+x\d*(@\dx)?(?=\.)/, '');
    }
    var files = slides.map(function (img) { return fileOf(img.getAttribute('src') || img.currentSrc); });

    function sync() {
      var opts = Array.prototype.slice.call(sec.querySelectorAll('.hn2-opt-input:checked'))
        .sort(function (a, b) { return a.getAttribute('data-pos') - b.getAttribute('data-pos'); })
        .map(function (i) { return i.value; });
      var v = null;
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var j = 0; j < opts.length; j++) { if (variants[i].options[j] !== opts[j]) { ok = false; break; } }
        if (ok) { v = variants[i]; break; }
      }
      if (!v || !v.featured_image || !v.featured_image.src) return;
      var want = fileOf(v.featured_image.src);
      var idx = files.indexOf(want);
      if (idx > -1 && gallery.__hn2go) gallery.__hn2go(idx);
    }
    sec.querySelectorAll('.hn2-opt-input').forEach(function (i) { i.addEventListener('change', sync); });
  }

  /* Klarna Pay in 4 has a $35 minimum — never show the line under it */
  function installmentsGuard(sec) {
    var box = sec.querySelector('[data-hn2-installments]');
    var dataEl = sec.querySelector('[data-hn2-variants]');
    if (!box || !dataEl) return;
    var min = parseInt(box.getAttribute('data-min'), 10) || 0;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    function check() {
      var opts = Array.prototype.slice.call(sec.querySelectorAll('.hn2-opt-input:checked'))
        .sort(function (a, b) { return a.getAttribute('data-pos') - b.getAttribute('data-pos'); })
        .map(function (i) { return i.value; });
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var j = 0; j < opts.length; j++) { if (variants[i].options[j] !== opts[j]) { ok = false; break; } }
        if (ok) { box.style.display = variants[i].price >= min ? '' : 'none'; return; }
      }
    }
    sec.querySelectorAll('.hn2-opt-input').forEach(function (i) { i.addEventListener('change', check); });
    check();
  }

  function init(scope) {
    scope.querySelectorAll('[data-hn2-gallery]').forEach(galleryControls);
    scope.querySelectorAll('[data-hn2-product]').forEach(function (sec) {
      variantGallerySync(sec);
      installmentsGuard(sec);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else { init(document); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
